import React from 'react';
import { Link } from 'react-router-dom';
import { Pencil, Trash2 } from 'lucide-react';
import useProcessing from './hooks/useProcessing';

interface ProcessingActionsProps {
    row: any;
    galleryId: number;
    onDelete: () => void;
}

export default function ProcessingActions({
    row,
    galleryId,
    onDelete,
}: ProcessingActionsProps) {
    const { deleteProcessingFlow } = useProcessing();

    return (
        <span className="flex items-center gap-2">
            <Link
                to={`gallery/${galleryId}/processing/edit/${row.original.id}`}
            >
                <Pencil className="size-4" />
            </Link>
            <Trash2
                onClick={async () => {
                    const deleteRecord = async () => {
                        await deleteProcessingFlow(row.original.id);
                        onDelete();
                    };

                    const shouldDelete = window.confirm(
                        `Are you sure you would like to delete this flow?`,
                    );

                    if (shouldDelete) {
                        deleteRecord();
                    }
                }}
                className="size-4 cursor-pointer"
            />
        </span>
    );
}
